export const BASIS_POINT_TOTAL = 10000;

export const PRICE_FILTER_MAX =
  '999999999999999999999999999999999999999999999999999999999999999999';
